import { BranchStep } from "./BranchStep";
import { DetailsStep } from "./DetailsStep";
import { PricesStep } from "./Prices";
import { UsersStep } from "./Users";

export const stepsConfig = [
  { title: "Details", component: DetailsStep },
  { title: "Branches", component: BranchStep },
  { title: "Users", component: UsersStep },
  { title: "Prices", component: PricesStep },
];
